import { render, staticRenderFns } from "./Reviewers.vue?vue&type=template&id=10d2056e&scoped=true&"
import script from "./Reviewers.vue?vue&type=script&lang=js&"
export * from "./Reviewers.vue?vue&type=script&lang=js&"
import style0 from "./Reviewers.vue?vue&type=style&index=0&id=10d2056e&prod&lang=css&"
import style1 from "./Reviewers.vue?vue&type=style&index=1&id=10d2056e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d2056e",
  null
  
)

export default component.exports